import { useTranslation } from 'react-i18next'
import { useCopilot } from '../hooks/useCopilot'
import { aggregateUnread } from '../state/machine'
import { Panel } from './Panel'

export function Launcher() {
  const { t } = useTranslation()
  const { state, open } = useCopilot()
  const unread = aggregateUnread(state)

  return (
    <>
      <button
        type="button"
        className={`copilot-launcher btn${unread > 0 ? ' copilot-launcher--alert' : ''}`}
        data-testid="copilot-launcher"
        aria-label={t('copilot.title')}
        onClick={open}
      >
        <i className="fa fa-stamp" aria-hidden="true" />
        {unread > 0 && <span className="copilot-launcher__badge">{unread}</span>}
      </button>
      <Panel />
    </>
  )
}
